import Utils from "../misc/Utils";

class Popups {
    static openPopup($trigger) {
        let targetSelector = $trigger.attr('data-popup-toggle');
        let $targetPopup =  jQuery('[data-popup-id="'+targetSelector+'"]');
        if(typeof $trigger.attr('data-popup-parent') !== 'undefined') {
            $targetPopup = $trigger.parents($trigger.attr('data-popup-parent')+':first').find('[data-popup-id="'+targetSelector+'"]');
        }
        $targetPopup.addClass('open').show().animate({'bottom' : 0}, 150);
        Utils.showBodyOverlay();
    };
    static closePopup() {
        let $openPopup = jQuery('.cs-popup.open');
        $openPopup.removeClass('open').animate({'bottom' : '-'+$openPopup.height()+'px'}, 150, 'swing', function () {
            $openPopup.hide();
        });
        Utils.hideBodyOverlay();
    }
    static initEvents() {
        jQuery(document.body)
            .on('click', '[data-popup-toggle]', function (evt) {
                evt.stopPropagation();
                Popups.openPopup(jQuery(this));
            })
            .on('click', '[data-close-popup]', function (evt) {
                evt.stopPropagation();
                Popups.closePopup();
            });
    }
    static initModule() {
        Popups.initEvents();
    }
}

export default Popups;